// extracted by mini-css-extract-plugin
export default {"root":"CookiePolicy_root__+7ZdA","lastUpdated":"CookiePolicy_lastUpdated__o+Ecu marketplaceBodyFontStyles"};